// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-order-success {
  max-width: 80vw;
  max-height: 80vh;
  background-color: rgb(233, 231, 222);
  padding: 30px 30px;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  gap: 30px;
  position: relative;
}

.popup-order-success__close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  border: none;
  background-color: rgba(122,148,90, 0.4);
  border-radius: 50%;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 20px rgb(122,148,90);
  padding: 25px;
  margin: 0;
}

.popup-order-success__close-button::before,
.popup-order-success__close-button::after {
  content: '';
  position: absolute;
  width: 80%;
  height: 4px;
  background-color: rgb(233, 238, 227);
  transition: background-color 0.3s ease;
}
  
.popup-order-success__close-button::before {
  transform: rotate(45deg);
}

.popup-order-success__close-button::after {
  transform: rotate(-45deg);
}

.popup-order-success__close-button:hover::before,
.popup-order-success__close-button:hover::after {
  background-color: #ff5722;
}

.popup-order-success__heading {
  margin: 0;
}

.popup-order-success__text {
    margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/PopupOrderSuccess.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;IACI,SAAS;AACb","sourcesContent":[".popup-order-success {\r\n  max-width: 80vw;\r\n  max-height: 80vh;\r\n  background-color: rgb(233, 231, 222);\r\n  padding: 30px 30px;\r\n  border-radius: 5px;\r\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 30px;\r\n  position: relative;\r\n}\r\n\r\n.popup-order-success__close-button {\r\n  position: absolute;\r\n  top: 20px;\r\n  right: 20px;\r\n  width: 40px;\r\n  height: 40px;\r\n  border: none;\r\n  background-color: rgba(122,148,90, 0.4);\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  box-shadow: 0px 0px 20px rgb(122,148,90);\r\n  padding: 25px;\r\n  margin: 0;\r\n}\r\n\r\n.popup-order-success__close-button::before,\r\n.popup-order-success__close-button::after {\r\n  content: '';\r\n  position: absolute;\r\n  width: 80%;\r\n  height: 4px;\r\n  background-color: rgb(233, 238, 227);\r\n  transition: background-color 0.3s ease;\r\n}\r\n  \r\n.popup-order-success__close-button::before {\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.popup-order-success__close-button::after {\r\n  transform: rotate(-45deg);\r\n}\r\n\r\n.popup-order-success__close-button:hover::before,\r\n.popup-order-success__close-button:hover::after {\r\n  background-color: #ff5722;\r\n}\r\n\r\n.popup-order-success__heading {\r\n  margin: 0;\r\n}\r\n\r\n.popup-order-success__text {\r\n    margin: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
